import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: any[];
  categoryName?: string;
  totalRecords?: number;
  value?: number | null;
  theFirstData?: any; // lấy ra phân tử đầu tiên của mảng để gen ra list header thay vì lấy toàn bộ sự thay đổi của mảng
}

// const groupByField = (data, fieldName) => {
//   const groups = data.reduce((acc, item) => {
//     const key = item[fieldName];
//     if (!acc[key]) {
//       acc[key] = [];
//     }
//     const { ...rest } = item;
//     acc[key].push(rest);
//     return acc;
//   }, {});

//   return Object.keys(groups).map((key) => ({
//     [fieldName]: key,
//     children: groups[key],
//   }));
// };

const initialState: InitialState = {};

const getHrReportSlice = createSlice({
  name: "getHrReport",
  initialState,
  reducers: {
    getHrReportStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getHrReportSuccess: (
      state,
      action: PayloadAction<{
        data: any[];
        categoryName?: string;
        totalRecords: number;
        value: number | null;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      // action.payload.data = groupByField(
      //   action.payload.data,
      //   "departmentLevel1Name"
      // );
      state.data = [...(state.data ?? []), ...action.payload.data];
      state.theFirstData = state.data?.[0];
      state.categoryName = action.payload.categoryName;
      state.totalRecords = action.payload.totalRecords;
      state.value = action.payload?.value;
    },
    getHrReportFailed: (state, action: PayloadAction<{ type: string }>) => {
      state = {
        status: ReduxStateType.ERROR,
        data: [],
        totalRecords: 0,
      };
    },
    resetHrReport: (state) => initialState,
  },
});

export const {
  getHrReportStart,
  getHrReportSuccess,
  getHrReportFailed,
  resetHrReport,
} = getHrReportSlice.actions;

export default getHrReportSlice.reducer;
